import { useTagStore } from '~/stores/tag'

import { AvailableInfluencerBadges as availableTags } from '~/enums/AvailableInfluencerBadges'

import type Tag from '~/entities/tag'

type BadgeName = (typeof availableTags)[number]

export function useGetHighestPriorityBadgeName(
  influencerBadges = [] as number[],
) {
  const { $pinia } = useNuxtApp()
  const { GET_TAGS_FROM_IDS } = useTagStore($pinia)

  return computed(() => {
    const dbNames: string[] = GET_TAGS_FROM_IDS(influencerBadges).map(
      (tag: Tag) => tag.name,
    )
    const tagNames: BadgeName[] = [
      ...availableTags.filter((tagName: string) => {
        return dbNames.includes(tagName)
      }),
    ]

    return tagNames[0]
  })
}
